export const PERIOD_TYPE_OPTIONS = [
  { value: true, label: "taxCalculator.periodType.monthly", name: "monthly" },
  { value: false, label: "taxCalculator.periodType.daily", name: "daily" },
];

export const WAGE_TYPE_OPTIONS = [
  {
    value: "daily",
    label: "taxCalculator.nonPermanent.wageType.daily",
    name: "dailyWage",
  },
  {
    value: "contract",
    label: "taxCalculator.nonPermanent.wageType.contract",
    name: "contractWage",
  },
];

export const CALCULATION_PERIOD_OPTIONS = [
  {
    value: "monthly",
    label: "taxCalculator.calculationPeriod.monthly",
    name: "calculationMonthly",
  },
  {
    value: "yearly",
    label: "taxCalculator.calculationPeriod.yearly",
    name: "calculationYearly",
  },
];

export const YEARLY_TYPE_OPTIONS = [
  {
    value: "actual",
    label: "taxCalculator.yearlyCalculationType.actual",
    name: "yearlyActual",
  },
  {
    value: "annualized",
    label: "taxCalculator.yearlyCalculationType.annualized",
    name: "yearlyAnnualized",
  },
];

export const CALCULATION_METHOD_OPTIONS = [
  {
    value: "full_year",
    label: "taxCalculator.calculationMethod.fullYear",
    name: "fullYear",
  },
  {
    value: "partial_year",
    label: "taxCalculator.calculationMethod.partialYear",
    name: "partialYear",
  },
  {
    value: "annualized",
    label: "taxCalculator.calculationMethod.annualized",
    name: "annualized",
  },
];

export const INPUT_MODE_OPTIONS = [
  {
    value: "monthly",
    label: "taxCalculator.inputMode.monthly",
    name: "inputMonthly",
  },
  {
    value: "annual",
    label: "taxCalculator.inputMode.annual",
    name: "inputAnnual",
  },
];

export const EMPLOYEE_TYPE_OPTIONS = [
  { value: "permanent", label: "taxCalculator.employeeType.permanent" },
  { value: "non-permanent", label: "taxCalculator.employeeType.nonPermanent" },
  { value: "retired", label: "taxCalculator.employeeType.retired" },
  { value: "freelance", label: "taxCalculator.employeeType.freelance" },
  { value: "non-resident", label: "taxCalculator.employeeType.nonResident" },
  {
    value: "activity-participant",
    label: "taxCalculator.employeeType.activityParticipant",
  },
  {
    value: "pension-withdrawal",
    label: "taxCalculator.employeeType.pensionWithdrawal",
  },
  {
    value: "former-employee",
    label: "taxCalculator.employeeType.formerEmployee",
  },
];

export const PROGRESSIVE_TAX_TYPES = [
  "activity-participant",
  "pension-withdrawal",
  "former-employee",
];

export const FORMER_EMPLOYEE_TYPES = ["former-employee"];

export const HAS_NPWP_OPTIONS = [
  { value: true, label: "common.yes" },
  { value: false, label: "common.no" },
];

export const HAS_NPPN_OPTIONS = [
  { value: true, label: "common.yes" },
  { value: false, label: "common.no" },
];
